import { DateInputBlock, DateRangeInputBlock } from '@coast/schemas';
import { i18n } from '@shared/util/i18n';

export function createStartDateInputBlock(block: DateRangeInputBlock): DateInputBlock {
  return {
    type: 'input',
    name: block.startDateFieldName ?? 'startDate',
    // @ts-expect-error -- strict migration
    fieldType: block.mode,
    placeholder: block.startDateFieldLabel ?? i18n('card.blocks.dateRangeInput.startDateLabel'),
    textStyle: 'body1',
    required: true,
    label: block.startDateFieldLabel ?? i18n('card.blocks.dateRangeInput.startDateLabel'),
    defaultTime: block.defaultTime,
    validation: {
      message: i18n('card.blocks.dateRangeInput.startDateError'),
    },
    autoFocus: false,
    icon: 'calendar',
  };
}

export function createEndDateInputBlock(block: DateRangeInputBlock): DateInputBlock {
  return {
    type: 'input',
    name: block.endDateFieldName ?? 'endDate',
    // @ts-expect-error -- strict migration
    fieldType: block.mode,
    placeholder: block.endDateFieldLabel ?? i18n('card.blocks.dateRangeInput.endDateLabel'),
    textStyle: 'body1',
    required: true,
    label: block.endDateFieldLabel ?? i18n('card.blocks.dateRangeInput.endDateLabel'),
    defaultTime: block.defaultTime,
    validation: {
      message: i18n('card.blocks.dateRangeInput.endDateError'),
    },
    autoFocus: false,
    icon: 'calendar',
  };
}
